import React from 'react';

interface DropboxIconProps {
  size?: number;
  className?: string;
}

const DropboxIcon: React.FC<DropboxIconProps> = ({ size = 24, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Official Dropbox logo - 5 diamond shapes */}
      <path d="M6 2L0 5.75L6 9.5L12 5.75L6 2Z" />
      <path d="M18 2L12 5.75L18 9.5L24 5.75L18 2Z" />
      <path d="M0 13.25L6 17L12 13.25L6 9.5L0 13.25Z" />
      <path d="M18 9.5L12 13.25L18 17L24 13.25L18 9.5Z" />
      <path d="M6 18.25L12 22L18 18.25L12 14.5L6 18.25Z" />
    </svg>
  );
};

export default DropboxIcon;
